import services from '@/services.js'

let getErrosObjectReponse = error => {
  let mges = []
  let obj = error.response.data.errors
  for (var props in obj) {
    mges.push({
      status: 'danger',
      text: obj[props][0] || 'ERROR',
    })
  }

  return mges || []
}

export default (editor, $vue) => {
  editor.Commands.add('delete-template', {
    run() {
      let organizationId = $vue.$store.state.auth.organizationId
      services
        .deleteTemplatesEmail(organizationId, { data: [$vue.hasTemplateId] })
        .then(({ data }) => {
          if (!$vue.$route.params.campaignId) {
            $vue.$router.push({
              name: 'new-template-list',
              params: {
                messages: [
                  {
                    status: 'success',
                    text: data.data.message || `the template ${$vue.templateName} was delete`,
                  },
                ],
              },
            })
          }

          if ($vue.$route.params.id) {
            delete $vue.$route.params.id
          }

          $vue.$router.push({
            name: 'new-template-list',
            params: {
              campaignId: $vue.$route.params.campaignId,
              indexChannel: $vue.$route.params.indexChannel,
              messages: [
                {
                  status: 'success',
                  text: data.data.message || `the template ${$vue.templateName} was delete`,
                },
              ],
            },
          })
        })
        .catch(({ response }) => {
          $vue.messages.push({
            status: 'danger',
            text: response.data.message || 'ERROR',
          })
        })
    },
    stop() {},
  })
  editor.Commands.add('save-template', {
    run(editor) {
      $vue.loagingPage = true
      $vue.messages = []

      // dentro de uma campanha a URL tem que ter todos esse atributos
      // if -será redirecionado para campanha como criação de um novo template
      // else  - para pagina de template

      //TODO Refatar para reduzir linhas de

      editor.store(resp => {
        $vue.loagingPage = false
        if (!resp.templateName) return

        if ($vue.$route.params.campaignId && $vue.$route.params.indexChannel.toString() && $vue.$route.params.id && $vue.templateName) {
          let organizationId = $vue.$store.state.auth.organizationId

          services
            .getTemplate(organizationId, $vue.$route.params.id)
            .then(({ data }) => {
              $vue.$router.push({
                name: 'campaignCreator',
                params: {
                  messages: [
                    {
                      status: 'success',
                      text: $vue.$t('templates.messages.template-saved-end-add-campaign', [data.data.name]),
                    },
                  ],
                  campaignId: $vue.$route.params.campaignId,
                  indexChannel: $vue.$route.params.indexChannel,
                  template: {
                    contentType: 2, // 1 = simples text || 2 = html
                    id: $vue.$route.params.id,
                    name: $vue.templateName,
                    thumbnailUri: `${$vue.$configs.VUE_APP_ROOT_API}template/email/static/${$vue.$route.params.id}/thumbnail.html`,
                    htmlFileUri: `${$vue.$configs.VUE_APP_ROOT_API}template/email/static/${$vue.$route.params.id}/index.jpg`,
                  },
                },
              })
            })
            .catch(error => {
              $vue.messages.push(...getErrosObjectReponse(error))
            })
            .finally(() => {
              $vue.loagingPage = false
            })
        } else {
          $vue.loagingPage = false
          $vue.$router.push({
            name: 'new-template-list',
            params: {
              messages: [
                {
                  status: 'success',
                  text: `the template ${$vue.templateName} was saved`,
                },
              ],
            },
          })
        }
      })
    },
  })
  editor.Commands.add('autosave-template', {
    run(editor, sender) {
      editor.store()
    },
  })
}
